import { graphql } from '@/generated/gql';

export const GET_EXTRACTED_REQUIREMENTS = graphql(/* GraphQL */ `
  query GetExtractedRequirements($input: SvbrgGetExtractedRequirementsInput!) {
    sevenbridges {
      getExtractedRequirements(input: $input) {
        stepType
        hasData
        data
      }
    }
  }
`);
